import { Button } from 'antd'
import { useState, VFC } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportCustomersUploadCsv } from '@/components/pages/Customer/Import'
import ImportPageHeader from '@/components/pages/ImportPageHeader'

import { useImportCustomer } from './Import.hooks'

const ImportCustomer: VFC = () => {
  const { importCustomerTypeInsert, loading } = useImportCustomer()
  const [fileName, setFileName] = useState('')
  const [t] = useTranslation()
  const [file, setFile] = useState<File | null>(null)

  const handleFileSelected = (data: FormData) => {
    const file = data.get('file') as File
    setFileName(file.name)
    setFile(file)
  }

  const handleSubmit = () => {
    if (file) {
      const payload = { idx: 0, codeIdx: 1, shortNameIdx: 2, nameIdx: 3 }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('payload', JSON.stringify(payload))

      importCustomerTypeInsert(formData)
    }
  }

  return (
    <>
      <ImportPageHeader title={t('pages.customers.importFromCsv.title')} />
      <ImportCustomersUploadCsv loading={loading} onUpload={handleFileSelected} fileName={fileName} />
      <Button disabled={!fileName} type="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
        {t('pages.employees.importFromCsv.submit')}
      </Button>
    </>
  )
}

ImportCustomer.displayName = 'ImportCustomer'
export default ImportCustomer
